import Swagger from "../../../../src/components/Swagger";
import * as React from 'react';
export default {
  Swagger,
  React
};